module.exports = __webpack_public_path__ + "static/media/bb8-carousel-arrow-active.6e64ec70.svg";